import http from "../../utils/http"

/**
 * 获取新闻列表
 */
export function usedList(params) {
    return http({
        url: "/api/used/page",
        data: params
    })
}


/**
 * 获取帮助详情
 */
export function usedDetail(params) {
    return http({
        url: "/api/used/detail",
        data: params
    })
}
